<template>
  <div>
    <v-dialog v-model="memberLevelDialog" max-width="400">
      <v-card>
        <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold">
          {{ config.title }}
        </v-card-title>

        <v-card-text class="pl-5">
          <p class="mb-0">
            {{ config.description }}
          </p>
        </v-card-text>

        <div class="pl-5">
          <div v-for="memberLevel in memberLevelItems" :key="memberLevel.group_no" class="d-flex align-center">
            <div v-if="memberLevel.group_no != parent_group_no" class="d-flex mt-2 mb-3">
              <v-checkbox
                v-model="memberLevelModal"
                color="primary"
                :value="memberLevel.group_no"
                hide-details
                class="mt-0 pt-0"
              ></v-checkbox>
              <p class="mb-0">
                {{ memberLevel.group_name }}
              </p>
            </div>
          </div>
        </div>

        <div class="button-container">
          <v-btn color="black" depressed class="white--text" @click="memberLevelDialog = false">
            닫기
          </v-btn>
          <v-btn color="primary" depressed class="white--text" @click="save()">
            설정
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

/**
 * 공통 예외 설정 모달 컴포넌트
 *
 * 사용 방법:
 * <ExceptionCommon
 *   ref="ExceptionCommon"
 *   :config="exceptionConfig"
 * />
 *
 * 설정 예시:
 * exceptionConfig: {
 *   type: 'group', // 'group', 'mileage', 'coupon'
 *   title: '자동 변경 제외 회원등급 설정',
 *   description: '선택한 회원등급은 정품 인증시 자동 변경하지 않습니다.',
 *   exceptionListKey: 'group_exception_list',
 *   parentMethodName: 'setGroupExceptionList'
 * }
 */
export default {
  name: "ExceptionCommon",
  props: {
    config: {
      type: Object,
      required: true,
      validator(value) {
        return value.type && value.title && value.description && value.exceptionListKey && value.parentMethodName;
      },
    },
  },
  data: () => {
    return {
      memberLevelDialog: false,
      memberLevelItems: [{ group_name: "", group_no: "" }],
      memberLevelModal: [],
      memberLevelCheckedParams: [],
      parent_index: null,
      parent_group_no: null,
    };
  },
  methods: {
    reset: function() {
      this.memberLevelDialog = false;
      this.memberLevelItems = [{ group_name: "", group_no: "" }];
      this.memberLevelModal = [];
      this.memberLevelCheckedParams = [];
      this.parent_index = null;
      this.parent_group_no = null;
    },

    /**
     * 모달 표시
     * @param {Object} params - 설정 데이터 (group_exception_list 등을 포함)
     * @param {Number} index - 부모 배열의 인덱스
     */
    show: async function(params, index) {
      console.log(`${this.config.type} exception params:`, params);
      this.reset();

      // 기존 예외 목록 로드
      const exceptionList = params && params[this.config.exceptionListKey];
      if (exceptionList && exceptionList.length > 0) {
        for (const exception of exceptionList) {
          this.memberLevelModal.push(exception.group_no);
        }
      }

      this.parent_index = index;
      this.parent_group_no = params.group_no;
      await this.searchLevel();
    },

    /**
     * 설정 저장
     */
    save: async function() {
      this.memberLevelCheckedParams = [];

      // 선택된 회원등급 정보 수집
      for (let i = 0; i < this.memberLevelModal.length; i++) {
        let info = this.memberLevelItems.find((item) => item.group_no === this.memberLevelModal[i]);
        if (info) {
          this.memberLevelCheckedParams.push(info);
        }
      }

      // 부모 컴포넌트의 해당 메소드 호출
      if (this.$parent[this.config.parentMethodName]) {
        this.$parent[this.config.parentMethodName](this.memberLevelCheckedParams, this.parent_index);
      } else {
        console.error(`Parent method '${this.config.parentMethodName}' not found`);
      }

      this.memberLevelDialog = false;
      alert("설정되었습니다.");
    },

    /**
     * 회원등급 목록 조회
     */
    searchLevel: async function() {
      try {
        let result = await M.api(M.entry("/get/groups/list"));
        this.memberLevelItems = result;
        this.memberLevelDialog = true;
      } catch (e) {
        alert("조회되지 않았습니다.");
        this.memberLevelItems = [
          {
            group_no: "1",
            group_name: "일반회원",
          },
          {
            group_no: "10",
            group_name: "라울-1회결제-등급",
          },
        ];
        this.memberLevelDialog = true;
      }
    },
  },
  mixins: [CommonMixin],
};
</script>

<style scoped>
/* 스크롤바로 인한 레이아웃 변화 방지 */
.v-dialog .v-card {
  overflow-y: auto;
  box-sizing: border-box;
}

/* 버튼 컨테이너 고정 */
.button-container {
  display: flex !important;
  gap: 12px;
  padding: 20px;
  flex-shrink: 0;
  min-width: 0;
  box-sizing: border-box;
  width: 100%;
}

.button-container .v-btn {
  flex: 1 1 0;
  min-width: 120px;
  max-width: none;
  white-space: nowrap;
}

/* 모달 내용 영역 안정화 */
.v-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
</style>
